export default __webpack_public_path__ + "static/dacs01-f87e82bacde72f6a490a3168aa165b2a.jpg";